import React from "react";
import Spinner from "./spinner";

function FallbackLoader() {
  return (
    <div style={{ height: "400px" }} className="d-flex align-items-center">
      <Spinner />
    </div>
  );
}

export default FallbackLoader;
